import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import QRCode from 'qrcode';

export const generateFiscalSponsorshipOverview = async () => {
  try {
    const doc = new jsPDF();

    const pageWidth = doc.internal.pageSize.width;

    // Generate QR Codes
    const qrCodeHomepage = await QRCode.toDataURL('https://causeandimpact.org');
    const qrCodeApply = await QRCode.toDataURL('https://causeandimpact.org/apply');

    const addHeader = () => {
      // Header Background
      doc.setFillColor(37, 99, 235); // Blue header background
      doc.rect(0, 0, pageWidth, 30, 'F');

      // Header Text
      doc.setFontSize(16);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(255, 255, 255);
      doc.text('Cause & Impact', 10, 20);

      // Subtext
      doc.setFontSize(10);
      doc.setFont('helvetica', 'italic');
      doc.text('Starting your nonprofit Cause never got easier!', 10, 27);

      // QR Code at Top
      doc.addImage(qrCodeHomepage, 'PNG', pageWidth - 35, 5, 25, 25);
    };

    const addFooter = () => {
      // Footer Background
      doc.setFillColor(5, 150, 105); // Green footer background
      doc.rect(0, 280, pageWidth, 10, 'F');

      // Footer Text
      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      doc.setTextColor(255, 255, 255);
      doc.text('Visit us at CauseandImpact.org | EIN: 32-0977089', 10, 286);
    };

    const addCallToAction = () => {
      const ctaYPosition = doc.lastAutoTable.finalY + 20;

      // Call-to-Action Background
      doc.setFillColor(37, 99, 235);
      doc.roundedRect(10, ctaYPosition, pageWidth - 20, 40, 5, 5, 'F');

      // Call-to-Action Text
      doc.setFontSize(14);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(255, 255, 255);
      doc.text('Ready to make an impact? Apply today at:', 20, ctaYPosition + 15);
      doc.setFontSize(12);
      doc.text('https://causeandimpact.org/apply', 20, ctaYPosition + 25);

      // QR Code for Apply URL
      doc.addImage(qrCodeApply, 'PNG', pageWidth - 40, ctaYPosition + 5, 25, 25);
    };

    // Add header and footer on the first page
    addHeader();
    addFooter();

    // Title Section
    doc.setFontSize(20);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(37, 99, 235);
    doc.text('Fiscal Sponsorship Overview', pageWidth / 2, 50, { align: 'center' });

    // Introduction Section
    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(70, 70, 70);
    doc.text(
      'Fiscal sponsorship is a powerful solution that enables emerging charitable initiatives to operate under the umbrella of an established 501(c)(3) organization. This arrangement provides immediate access to tax-exempt benefits, professional nonprofit infrastructure, and comprehensive support services.',
      10,
      60,
      { maxWidth: pageWidth - 20 }
    );

    // Sponsorship Models Table
    doc.autoTable({
      startY: 90,
      head: [['Sponsorship Models', 'Description', 'Best For']],
      body: [
        ['Comprehensive (Model A)', 'Complete integration with sponsor organization.', 'New initiatives and grassroots projects.'],
        ['Pre-Approved Grant (Model C)', 'Project maintains independence while receiving tax-deductible donations.', 'Established projects.'],
        ['Technical Assistance', 'Sponsor provides administrative guidance and operational support.', 'Organizations needing specific services.'],
        ['Group Exemption', 'Sponsor extends tax-exempt status to multiple affiliated organizations.', 'Networks of related organizations.']
      ],
      styles: { fontSize: 10, cellPadding: 5, textColor: [70, 70, 70] },
      headStyles: { fillColor: [37, 99, 235], textColor: [255, 255, 255] },
      margin: { left: 10, right: 10 }
    });

    // Key Benefits Table
    doc.autoTable({
      startY: doc.lastAutoTable.finalY + 10,
      head: [['Key Benefits']],
      body: [
        ['• Immediate Access to Tax-Exempt Status'],
        ['• Reduced Administrative Costs'],
        ['• Professional Financial Management'],
        ['• Comprehensive Legal Compliance'],
        ['• Grant Management & Administration'],
        ['• Human Resources Management'],
        ['• Online Donation Processing'],
        ['• Financial Reporting Dashboard']
      ],
      styles: { fontSize: 10, cellPadding: 5 },
      headStyles: { fillColor: [5, 150, 105], textColor: [255, 255, 255] },
      margin: { left: 10, right: 10 }
    });

    // Call-to-Action Section
    addCallToAction();

    // Apply footer to all pages
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      addFooter();
    }

    return doc;
  } catch (error) {
    console.error('Error generating PDF:', error);
    return null;
  }
};
